export default {
  plaidLinkToken: "plaidLinkToken",
};
